import Modal from '@/components/Modal/';
import { noop } from '@/utils/util';
import React, { Component } from 'react';
import classNames from 'classnames';
import i18n from 'react-intl-universal';
import _ from 'lodash';
import styles from './EditorModal.scss';
import Button from '../../components/Button/Button';
import Message from '../Message';
import ajax from '../../utils/ajax';

const MAX_FILM_COUNT = 10; // 最多展示的电影个数
const HEART_COUNT = 5; // 心形个数，每半个心算1分，满分10分

// 插入编辑器时的评分文案，如"评分：6分"
export const getFilmScoreText = score => `${i18n.get('modal.film-score')}：${score}${i18n.get('modal.film-score-unit')}`;

export default class EditorFilmModal extends Component {
  static defaultProps = {
    onModalCancelClick: noop,
    onModalConfirmBtnClick: noop,
  };

  constructor(props) {
    super(props);
    this.state = {
      keyword: '', // 搜索关键字
      films: [], // 搜索到的电影列表
      selectedFilm: null, // 当前选中的电影
      score: 6, // 当前评分，默认6分(3个满心)
    };
    this.searchFilms = _.debounce(this.fetchFilms, 300);
  }

  componentWillUnmount() {
    this.searchFilms.cancel();
  }

  onKeywordChange = (e) => {
    const keyword = e.target.value;
    console.log('[film] keyword change:', keyword);
    this.setState({
      keyword,
      films: [],
      selectedFilm: null,
    });
    // 输入1个字后才开始搜索
    if (keyword.trim().length >= 1) {
      this.searchFilms(keyword.trim());
    }
  };

  fetchFilms = (keyword) => {
    console.log('[film] fetchFilms begin, keyword:', keyword);
    ajax.searchFilms(keyword).then((res) => {
      console.log('[film] search response status:', res && res.status, 'body:', res && res.data);
      // 忽略过期的请求结果
      if (keyword !== (this.state.keyword || '').trim()) {
        console.log('[film] ignore stale response, current keyword:', this.state.keyword);
        return;
      }
      const body = (res && res.data) || {};
      if (body.code !== 100) {
        console.error('[film] search response code invalid:', body.code, body);
        Message.error(`${i18n.get('modal.film-search-fail')}（code: ${body.code}）`);
        return;
      }
      const films = (body.data || []).slice(0, MAX_FILM_COUNT);
      console.log('[film] films to show:', films.length, films.map(f => f.title));
      this.setState({
        films,
      });
    }).catch((err) => {
      // axios 拦截器在 HTTP 报错时 reject 的是响应体对象，err.status 即状态码；
      // 网络层/跨域报错时 err 才是 axios 错误对象，此时状态码记为 none
      const status = (err && (err.status || (err.response && err.response.status))) || 'none';
      console.error('[film] search failed, status:', status, 'err:', err);
      Message.error(`${i18n.get('modal.film-search-fail')}（${status}）`);
    });
  };

  onFilmClick = (film) => {
    this.setState({
      selectedFilm: film,
    });
  };

  onScoreClick = (e) => {
    const score = +e.currentTarget.getAttribute('data-score');
    this.setState({
      score,
    });
  };

  onConfirmBtnClick = () => {
    const { onModalConfirmBtnClick } = this.props;
    const { selectedFilm, score } = this.state;
    if (!selectedFilm) {
      Message.error(i18n.get('modal.film-select-tip'));
      return;
    }
    onModalConfirmBtnClick('filmModal', { film: selectedFilm, score });
  };

  getScoreLabel = () => {
    const { score } = this.state;
    if (score <= 0) {
      return '';
    }
    if (score <= 2) {
      return i18n.get('modal.film-score-bad');
    }
    if (score <= 4) {
      return i18n.get('modal.film-score-poor');
    }
    if (score <= 6) {
      return i18n.get('modal.film-score-ok');
    }
    if (score <= 8) {
      return i18n.get('modal.film-score-good');
    }
    return i18n.get('modal.film-score-great');
  };

  // 5个心形，每半个心算1分，点击左/右半边分别得奇数/偶数分
  renderHearts = () => {
    const { score } = this.state;
    const hearts = [];
    for (let i = 0; i < HEART_COUNT; i++) {
      const fill = Math.max(0, Math.min(2, score - (i * 2))); // 0空 1半 2满
      const heart = (
        <span key={i} className={styles['film-heart']}>
          <i className={classNames('fa', 'fa-heart', styles['film-heart-empty'])}/>
          <span className={styles['film-heart-fill']} style={{ width: `${fill * 50}%` }}>
            <i className={classNames('fa', 'fa-heart', styles['film-heart-full'])}/>
          </span>
          <span className={styles['film-heart-left']} data-score={(i * 2) + 1} onClick={this.onScoreClick}/>
          <span className={styles['film-heart-right']} data-score={(i * 2) + 2} onClick={this.onScoreClick}/>
        </span>
      );
      hearts.push(heart);
    }
    return hearts;
  };

  render() {
    const { onModalCancelClick } = this.props;
    const { keyword, films, selectedFilm } = this.state;
    return (
      <Modal
        width={412}
        visible
        showFooter={false}
        showMask
        closable
        isMiddle
        onCancel={onModalCancelClick}
      >
        <div className={classNames(styles['kalamu-modal'], styles['kalamu-film-modal'])}>
          <h3>{i18n.get('modal.insertfilm')}</h3>
          <div className={styles['modal-body']}>
            <div className={styles['input-prepend']}>
              <span className={styles['add-on']}>
                <i className="fa fa-film"/>
              </span>
              <input
                autoFocus
                placeholder={i18n.get('modal.film-placeholder')}
                type="text"
                value={keyword}
                onChange={this.onKeywordChange}
              />
            </div>
            {
              films.length > 0 &&
              <ul className={styles['film-list']}>
                {
                  films.map((film) => {
                    return (
                      <li
                        key={film.id}
                        className={classNames({
                          [styles['film-item-active']]: selectedFilm && selectedFilm.id === film.id,
                        })}
                        onClick={() => this.onFilmClick(film)}
                      >
                        {film.title}
                      </li>
                    );
                  })
                }
              </ul>
            }
            <div className={styles['film-score']}>
              {this.renderHearts()}
              <span className={styles['film-score-label']}>{this.getScoreLabel()}</span>
            </div>
            <div className={styles['btn-wrap']}>
              <Button type={'primary'} className={styles['btn']} onClick={this.onConfirmBtnClick}>
                {i18n.get('modal.confirm')}
              </Button>
              <Button className={styles['btn']} onClick={onModalCancelClick}>
                {i18n.get('modal.cancel')}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditorModal/EditorFilmModal.js